import React, { useMemo, useState } from "react";
import Table from "components/common/Table";
const moment = require("moment");

const computeColumns = ({
  setRowExpanded,
  setRowInfo,
  updateToNotes,
  removeFromNotes,
}) => [
  {
    Header: "Date",
    accessor: (data) => (
      <div className="whitespace-nowrap align-top">
        {moment.unix(data.created_at / 1000).format("M/D/YYYY LT")}
      </div>
    ),
    style: { verticalAlign: "top" },
  },
  {
    Header: "IP Address",
    accessor: "ip_address",
    style: { verticalAlign: "top" },
  },
  {
    Header: "Session Id",
    accessor: (data) => (data.session_id || "").slice(-6),
  },
  {
    Header: "Location",
    accessor: (data) =>
      [
        data.city || "",
        (data.subdivisions || []).join("/"),
        data.postal || "",
        data.country || "",
      ]
        .filter((e) => e)
        .join(", "),
  },
  {
    Header: "Device",
    accessor: (data) =>
      [data.browser || "", data.os || "", data.device_type || ""]
        .filter((e) => e)
        .join(", "),
  },
];

const IpAddressTable = ({ user = {} }) => {

    const columns = useMemo(() => computeColumns({}));

    return (
        <div className='my-5'>
            <h1 className="text-2xl font-title mb-2 font-light">IP Address Data</h1>
            {
                (user.ip_addresses || []).length ? 
                    (
                        <Table
                            id="ip-table"
                            data={user.ip_addresses}
                            columns={columns}
                            // getRowStyle={getRowStyle}
                            itemsPerPage={20}
                        />
                    ) : (
                        <div className='mb-5'>User has no ip address record</div>
                    )
            }
        </div>
    );
};

export default IpAddressTable;